import(/* webpackMode: "eager", webpackExports: ["BebrasPageContent"] */ "/app/src/app/(whithRootLayout)/kangaroo/Contents.tsx");
